export default __webpack_public_path__ + "static/poynt-3303-660a4e53a4f9df8165669c933f1b2caf.png";